import React from 'react'
import {Card, CardHeader, Col, Table,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import dateHelpers from "../../helpers/DateHelper";

const propTypes = {};

export default class AdminSubscriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptions: null,
            isLoading: false,
        };
    }

    onUserIdSelected = this.onUserIdSelected.bind(this)

    componentDidMount() {
        this.getData()
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    render() {

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Card className="bg-default shadow">
                        <Card className="bg-default shadow">
                            <CardHeader className="bg-transparent">
                                <Row>
                                    <h5 className="text-warning mb-0">Subscriptions ({this.state.subscriptions ? this.state.subscriptions.length : 0})</h5>
                                </Row>
                            </CardHeader>
                            {this.state.subscriptions !== null && this.renderReport()}
                        </Card>
                    </Card>
                </>
            </LoadingOverlay>
        )
    }


    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-id":
                this.setState({userId: newValue});
                break;
            case "input-last":
                this.setState({numberOfEvents: newValue});
                break;
            default:
                break;
        }
    }

    renderReport() {
        return <Col lg="12">
            <Card>
                <Table
                    className="align-items-center table-light table-flush mt-2"
                    responsive
                >
                    <thead className="thead-light">
                    <tr>
                        <th scope="col">User ID</th>
                        <th scope="col">User NAME</th>
                        <th scope="col">title</th>
                        <th scope="col">expires</th>
                        <th scope="col">type</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    </tbody>
                </Table>
            </Card>
        </Col>
    }

    renderTable() {
        if (this.state.events !== null) {
            return this.state.subscriptions.map((subscription, index) => {
                return (
                    <tr>
                        <td>
                            <a href="#" onClick={(e) => this.onUserIdSelected(e, subscription.user_id)}>{subscription.user_id}</a>
                        </td>
                        <td>
                            {subscription.user}
                        </td>
                        <td>
                            {subscription.name}
                        </td>
                        <td>
                            {subscription.expires_at ? dateHelpers.databaseDateTime(new Date(subscription.expires_at)) : ""}
                        </td>
                        <td>
                            {this.subscriptionsType(subscription)}
                        </td>
                    </tr>
                )
            })
        }
    }

    getData() {
        if (this.state.searchValue !== null) {
            this.setState({isLoading: true});
            reportApiService.admin_subscriptions()
                .then(res => {
                    this.setState({
                        isLoading: false,
                        subscriptions: res
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    onUserIdSelected(e, user_id) {
        e.preventDefault();
        this.setState({userId: user_id})
    }

    subscriptionsType(subscription) {
        if (!subscription.expires_at) return "Android"
        else if (subscription.name.includes("eur") || subscription.name.includes("rub") || subscription.name.includes("usd") || subscription.name.includes("uah")) return "Web"
        else return "iOS"
    }
}

AdminSubscriptions.propTypes = propTypes;